import { CogniteClient } from '@cognite/sdk';

export const sdk = new CogniteClient({ appId: 'Discovery' });
